module.exports = __webpack_public_path__ + "static/media/geoportal.f04658bc.jpg";